import React from 'react'
import styles from './styles.module.css'

// component function
export default function InfoBox(props) {
	
	const {analysisType} = props

	return (
		<div className={styles.container}>
			<div className={styles.heading}>Heads up</div>
			<div className={styles.infoContainer}>
				<div className={styles.infoText}>Object {analysisType === 3 ? 'detection' : 'tracking'} and labeling isn’t always perfect - it may occasionally misread certain elements in your ad. Don’t worry, this is completely normal. You can always change the labeling while you tag, or after.</div>
			</div>
		</div>
	)
}
